import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import { Menu as MenuIcon } from "@mui/icons-material";
import logo from "../assets/logo_sq.svg";
import PrescriptionNavbar from "./prescription/PrescriptionNavbar";
import NurseNavbar from "./nurse/NurseNavbar";
import AppointmentNavbar from "./appointment/AppointmentNavbar";
import BillingNavbar from "./billing/BillingNavbar";
import LabNavbar from "./lab/LabNavbar";
import PharmacyNavbar from "./pharmacy/PharmacyNavbar";
import { useSelector } from "react-redux";

const Navbar = () => {
  const isMdUp = useMediaQuery("(min-width:700px)");
  // const isCompact = useMediaQuery('(max-width: 1450px)');
  const authState = useSelector((state) => state.auth);
  const [path, setPath] = useState(authState?.redirect || "");

  const renderNavbar = (path) => {
    switch (path) {
      case "/appointments":
        return (
          <AppointmentNavbar />
        );

      case "/billing":
        return (
          <BillingNavbar />
        );

      case "/lab":
        return (
          <LabNavbar />
        );

      case "/prescription":
        return (
          < PrescriptionNavbar />
        );

      case "/quick_check":
        return (
          <NurseNavbar />
        );

      case "/pharmacy":
        return (
          <PharmacyNavbar />
        );

      default:
        return null;
    }
  };

  return (
    <>
      <AppBar
        sx={{ background: "#FFFFFF", padding: isMdUp ? "8px 0px" : '2px', boxShadow: "none" }}
        position="fixed"
      >
        {renderNavbar(path)}
      </AppBar>
    </>
  );
};

export default Navbar;
